import script from "./BaseBreadcrumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseBreadcrumb.vue?vue&type=script&setup=true&lang=ts"

import "./BaseBreadcrumb.vue?vue&type=style&index=0&id=db3ead2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.38_typescript@5.9.3__webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db3ead2a"]])

export default __exports__